// extracted by mini-css-extract-plugin
export default {"scale":"style_scale__uGmOa","scale__item":"style_scale__item__ojMWz","fill":"style_fill__CEOZ6"};